import { defineAsyncComponent } from 'vue'
export default {
  form: defineAsyncComponent(() => import("/opt/build/repo/apps/act/layouts/form.vue").then(m => m.default || m))
}